export default function Footer() {
  return (
    <div className=' footer absolute w-full left-0 bottom-0 flex justify-center'></div>
  );
}
